// The six category tints, in one place.
//
// Mirrors iOS `QuestionCategory.sectionTint(for:)`. Values come from
// theme.css, which carries light/dark variants behind the same var name — so
// referencing the var (rather than a hex) keeps both schemes correct for free.
//
// NOTE `--frame-technology` for Discovery: Technology was renamed Discovery
// 2026-07-23, but the CSS var (like the Firestore wire value) still carries
// the legacy name. Don't "fix" the mismatch — it's load-bearing for back-compat.

export const CATEGORY_TINT = {
  Sports: 'var(--frame-sports)',
  Markets: 'var(--frame-markets)',
  Politics: 'var(--frame-politics)',
  Culture: 'var(--frame-culture)',
  Discovery: 'var(--frame-technology)',
  World: 'var(--frame-world)',
};

/** Tint for a category, falling back to gold for anything unrecognised. */
export function categoryTint(category) {
  return CATEGORY_TINT[category] || 'var(--gold)';
}
